import React from 'react';
import { Alert, CircularProgress } from '@mui/material';

export const TableStatusHeader = ({ text }) => {
  return (
    <Alert severity='info' icon={ <CircularProgress size={20} />}>
      {text}
    </Alert>
  )
}